export default __webpack_public_path__ + "static/media/Calibri-Bold-Italic.da07dc13.ttf";